import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import Services from "./pages/services";
import Contact from "./pages/contact";
import Privacy from "./pages/privacy";
import Terms from "./pages/terms";
import FAQ from "./pages/faq";
import NoPage from "./pages/NoPage";
import useScrollToTop from "./hooks/useScrollToTop";
import { StagewiseToolbar } from "@stagewise/toolbar-react";
import { ReactPlugin } from "@stagewise-plugins/react";

export default function App() {
  // Scroll to the top on every successful route transition
  useScrollToTop();
  return (
    <>
      <StagewiseToolbar config={{ plugins: [ReactPlugin] }} />
      <Routes>
        <Route index element={<Home />} />
        <Route path="services" element={<Services />} />
        <Route path="contact" element={<Contact />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="terms" element={<Terms />} />
        <Route path="faq" element={<FAQ />} />
        <Route path="*" element={<NoPage />} />
      </Routes>
    </>
  );
}
